import { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import { fromJS } from 'immutable';
import mixpanel from 'mixpanel-browser';

// COMPONENTS
import MaybeTranslation from 'components/MaybeTranslation';

// STYLES
import { Relative, Modal, Title, Close, CancelButton, SaveButton } from 'styles/modals';
import {
  Container,
  Header,
  SearchContainer,
  Input,
  SubHeader,
  Content,
  RowContainer,
  DragIcon,
  DragContainer,
  CheckboxContainer,
  Checkbox,
  Footer,
  IS_SORTING,
} from './EditColumns.styles';

// CONSTANTS
import { ANALYTICS_EVENTS } from 'constants/mixpanel.constants';

const DragHandle = SortableHandle(() => (
  <DragContainer data-testid="edit-columns__drag-handle">
    <DragIcon className="icon-drag" />
  </DragContainer>
));

const Row = SortableElement((props) => (
  <RowContainer data-testid="edit-columns__checkbox-container">
    <DragHandle />
    <CheckboxContainer onClick={props.onToggleColumnVisibility(props.rowIndex)}>
      <Checkbox checked={!props.column.disabled}>
        <i className="icon-check" />
      </Checkbox>
      <MaybeTranslation renderedValue={props.relatedField.get('title')} />
    </CheckboxContainer>
  </RowContainer>
));

const Rows = SortableContainer((props) => {
  const columnElements = props.columns.map((column, key) => {
    const relatedField = props.fields.find((field) => field.get('name') === column.field);

    if (!relatedField) {
      return null;
    }

    return (
      <Row
        key={`item-${column.field}`}
        className={props.isSorting ? IS_SORTING : undefined}
        index={key}
        rowIndex={key}
        column={column}
        relatedField={relatedField}
        onToggleColumnVisibility={props.onToggleColumnVisibility}
      />
    );
  });

  return <Content className={props.isSorting ? IS_SORTING : undefined}>{columnElements}</Content>;
});

class EditColumns extends Component {
  state = {
    // @ts-expect-error TS(2339): Property 'fields' does not exist on type 'Readonly... Remove this comment to see the full error message
    filteredFields: this.props.fields,
    isSorting: false,
    query: '',
    // @ts-expect-error TS(2339): Property 'columnConfig' does not exist on type 'Re... Remove this comment to see the full error message
    newColumnOrder: this.props.columnConfig.toJS(),
  };

  handleChangeQuery = (event) => {
    const {
      currentTarget: { value },
    } = event;
    let filteredFields;

    // @ts-expect-error TS(2339): Property 'fields' does not exist on type 'Readonly... Remove this comment to see the full error message
    ({ fields: filteredFields } = this.props);

    if (typeof value === 'string') {
      // @ts-expect-error TS(2339): Property 'fields' does not exist on type 'Readonly... Remove this comment to see the full error message
      filteredFields = this.props.fields.filter((field) => {
        let renderedValue = field.toJS().title;

        if (renderedValue.translationId) {
          // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
          renderedValue = this.props.intl.formatMessage({
            id: renderedValue.translationId,
          });
        }

        return renderedValue.toLowerCase().includes(value.toLowerCase());
      });

      this.setState({
        query: value,
        filteredFields,
      });
    }
  };

  handleOnSave = () => {
    // @ts-expect-error TS(2339): Property 'onSave' does not exist on type 'Readonly... Remove this comment to see the full error message
    this.props.onSave(fromJS(this.state.newColumnOrder));
  };

  handleCloseModal = () => {
    // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
    this.props.onCloseModal();
  };

  handleToggleColumnVisibility = (index) => () => {
    const newColumnOrder = [...this.state.newColumnOrder];
    newColumnOrder[index].disabled = !newColumnOrder[index].disabled;
    this.setState({
      newColumnOrder,
    });
  };

  handleOnSortStart = () => {
    this.setState({ isSorting: true });
  };

  handleOnSortEnd = ({ oldIndex, newIndex }) => {
    let newColumnOrder = arrayMove(this.state.newColumnOrder, oldIndex, newIndex);
    newColumnOrder = newColumnOrder.map((column, index) => ({
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...column,
      position: index,
    }));

    this.setState({
      newColumnOrder,
      isSorting: false,
    });
  };

  render() {
    return (
      <Container>
        <Relative>
          {/* @ts-expect-error TS(2769): No overload matches this call. */}
          <Modal loading={this.props.loading}>
            <Header>
              <Title>
                <FormattedMessage id="components.Modals.EditColumns.title" />
              </Title>
              <Close
                onClick={() => {
                  // @ts-expect-error TS(2339): Property 'onCloseModal' does not exist on type 'Re... Remove this comment to see the full error message
                  this.props.onCloseModal();
                  mixpanel.track(ANALYTICS_EVENTS.CLOSE_MODAL);
                }}
                className="icon-close-light"
              />
            </Header>
            <SearchContainer>
              <Input
                data-testid="edit-columns__search"
                type="text"
                name="query"
                // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
                placeholder={this.props.intl.formatMessage({
                  id: 'components.Modals.EditColumns.searchPlaceholder',
                })}
                value={this.state.query}
                onChange={this.handleChangeQuery}
              />
            </SearchContainer>

            <SubHeader>
              <FormattedMessage id="components.Modals.EditColumns.selectLabel" />
            </SubHeader>

            <Rows
              fields={this.state.filteredFields}
              columns={this.state.newColumnOrder}
              helperClass="draggableStyle"
              isSorting={this.state.isSorting}
              lockAxis="y"
              onSortEnd={this.handleOnSortEnd}
              onSortStart={this.handleOnSortStart}
              onToggleColumnVisibility={this.handleToggleColumnVisibility}
              useDragHandle
            />

            <Footer>
              <CancelButton
                onClick={this.handleCloseModal}
                // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
                disabled={this.props.loading}
                data-testid="column-edit-modal-cancel"
              />
              <SaveButton
                onClick={this.handleOnSave}
                // @ts-expect-error TS(2339): Property 'loading' does not exist on type 'Readonl... Remove this comment to see the full error message
                disabled={this.props.loading}
                data-testid="column-edit-modal-save"
              >
                <FormattedMessage id="components.Modals.EditColumns.apply" />
              </SaveButton>
            </Footer>
          </Modal>
        </Relative>
      </Container>
    );
  }
}

// @ts-expect-error TS(2769): No overload matches this call.
export default injectIntl(EditColumns);
